import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
//Components
import TextField from '../../../../components/TextField/TextField';
import Loading from '../../../../components/Loading/Loading';
//Api
import rotaColeta_api from '../../../../api/rotaColeta_api';
//Helpers
import { showMessage } from '../../../../helpers/message';
import { validarCampos } from '../../../../helpers/ValidadorDeCampos';

export default function IdentificacaoRota({ campos = [], errors, setErrors, rotaColeta, setRotaColeta, ordemAvulsa }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado das opções do select de veiculos
    const [optionsVeiculos, setOptionsVeiculos] = useState([
        { text: "Selecione", value: "" },
    ]);
    //Estado das opções do select de destinos
    const [optionsDestinos, setOptionsDestinos] = useState([{ text: "Selecione", value: "" }]);
    //Estado das opções do select de status
    const optionsStatus = [
        { text: "Ativo", value: "Ativo" },
        { text: "Inativo", value: "Inativo" },
    ]

    //Carrega as opções de destinos e veiculos assim que a tela é iniciada
    useEffect(() => {
        setLoading(true);
        if (rotaColeta.tbVeiculos_Id !== "") {
            loadDestinos(rotaColeta.tbVeiculos_Id);
        }
        rotaColeta_api.GetVeiculosDisponiveis().then(response => {
            response.data = response.data.map(value => {
                return { text: value.placa, value: value.id }
            })
            setOptionsVeiculos([{ text: "Selecione", value: "" }, ...response.data]);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }, []);

    //Change para os campos da rota de coleta
    const onChangeRota = (e) => {
        const { name, value } = e.target;
        const _rotaColeta = {
            ...rotaColeta,
            [name]: value
        };
        const campo = campos.filter(campo => campo.name === name);
        const _errors = validarCampos(_rotaColeta, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] })
        } else {
            const novosErrors = { ...errors };
            delete novosErrors[name];
            setErrors(novosErrors);
        }
        setRotaColeta(_rotaColeta);
    }
    //Carrega os destinos disponiveis para o veiculo enviado
    const loadDestinos = (idVeiculo) => {
        rotaColeta_api.GetDestinosDisponiveisPorVeiculo(idVeiculo).then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, text: value.fantasia }
            })
            setOptionsDestinos([{ text: "Selecione", value: "" }, ...response.data]);
        }).catch(e => showMessage("Aviso", e.message, "error", null));
    }
    //OnChange para o select de veiculo
    const onChangeVeiculo = (e) => {
        const { name, value } = e.target;
        if (value !== "") {

            const [veiculo] = optionsVeiculos.filter(v => v.value === parseInt(value));
            const _rotaColeta = {
                ...rotaColeta,
                [name]: value,
                placaVeiculo: veiculo.text
            }
            const campo = campos.filter(campo => campo.name === name);
            const _errors = validarCampos(_rotaColeta, campo);
            if (_errors[1].length > 0) {
                setErrors({ ...errors, ..._errors[0] })
            } else {
                const novosErrors = { ...errors };
                delete novosErrors[name];
                setErrors(novosErrors);
            }
            //Pega os destinos disponiveis para o veiculo selecionado
            if (value !== "")
                loadDestinos(value);

            setRotaColeta(_rotaColeta);
        } else {
            setRotaColeta({
                ...rotaColeta,
                [name]: value,
                placaVeiculo: ""
            })
        }
    }
    //OnChange para o select de destino
    const onChangeDestino = (e) => {
        const { name, value } = e.target;
        const [destino] = optionsDestinos.filter(d => d.value === parseInt(value));
        const _rotaColeta = {
            ...rotaColeta,
            [name]: value,
            fantasiaDestino: destino.text
        }
        const campo = campos.filter(campo => campo.name === name);
        const _errors = validarCampos(_rotaColeta, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] })
        } else {
            const novosErrors = { ...errors };
            delete novosErrors[name];
            setErrors(novosErrors);
        }
        setRotaColeta(_rotaColeta);
    }
    return (
        <div>
            {loading && <Loading />}
            <Row>
                <Col md="12" lg="4">
                    <TextField label={"* Descrição"} maxLength={"300"} onChange={onChangeRota} name={'descricao'} value={ordemAvulsa ? "Ordem Avulsa" : rotaColeta.descricao} invalid={errors.descricao ? true : false} />
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"* Veículo"} onChange={onChangeVeiculo} name={'tbVeiculos_Id'} type={"select"} options={optionsVeiculos} value={rotaColeta.tbVeiculos_Id} invalid={errors.tbVeiculos_Id ? true : false} />
                </Col>

                <Col md="12" lg="4">
                    <TextField label={"* Destino"} onChange={onChangeDestino} name={'tbDestinos_Id'} type={"select"} options={optionsDestinos} value={rotaColeta.tbDestinos_Id} invalid={errors.tbDestinos_Id ? true : false} />
                </Col>

                <Col md="12" lg="4">
                    <TextField label={"* Status"} name={'status'} type={"select"} options={optionsStatus} value={rotaColeta.status} onChange={onChangeRota} invalid={errors.status ? true : false} />
                </Col>
            </Row>
        </div>
    )
}
